// src/i18n/es/wall.ts
// «Pantalla de pared» (mockup 02) — the chrome-less, always-on reception
// screen at `/#/panel?hotel=<id>`.
export const wall = {
  updatedAt: 'Actualizado a las %{time}',
  offline: 'Sin conexión',
  offlineDescription: 'No se ha podido actualizar la información. Reintentando…',
  page: 'Página %{page} de %{total}',
};

export default wall;
